import { areaData } from './areaData';

function findProvinceNode(provinceCode) {
  return areaData.find((province) => province.value === provinceCode) || null;
}

function findCityNode(provinceNode, cityCode) {
  if (!provinceNode || !Array.isArray(provinceNode.children)) {
    return null;
  }

  return provinceNode.children.find((city) => city.value === cityCode) || null;
}

function findCountyNode(cityNode, countyCode) {
  if (!cityNode || !Array.isArray(cityNode.children)) {
    return null;
  }

  return cityNode.children.find((county) => county.value === countyCode) || null;
}

export function getAreaLabelsByCodes(codes = []) {
  if (!Array.isArray(codes) || codes.length === 0) {
    return { province: '', city: '', county: '', path: [] };
  }

  const [provinceCode, cityCode, countyCode] = codes;
  const provinceNode = findProvinceNode(provinceCode);
  const cityNode = findCityNode(provinceNode, cityCode);
  const countyNode = findCountyNode(cityNode, countyCode);

  const province = provinceNode?.label || '';
  const city = cityNode?.label || '';
  const county = countyNode?.label || '';

  return {
    province,
    city,
    county,
    path: [province, city, county].filter(Boolean)
  };
}

export function getAreaCodesByLabels({ province, city, county } = {}) {
  if (!province) {
    return [];
  }

  const provinceNode = areaData.find((item) => item.label === province);
  if (!provinceNode) {
    return [];
  }

  if (!city) {
    return [provinceNode.value];
  }

  const cityNode = (provinceNode.children || []).find((item) => item.label === city);
  if (!cityNode) {
    return [provinceNode.value];
  }

  if (!county) {
    return [provinceNode.value, cityNode.value];
  }

  const countyNode = (cityNode.children || []).find((item) => item.label === county);
  if (!countyNode) {
    return [provinceNode.value, cityNode.value];
  }

  return [provinceNode.value, cityNode.value, countyNode.value];
}

export function formatAreaText(province, city, county) {
  return [province, city, county].filter(Boolean).join(' / ');
}
